import React from "react";
import PropTypes from "prop-types";

const ShiftTable = ({ data }) => {
  if (!data || data.length === 0) {
    return <p>No data available</p>;
  }

  // Get table headers dynamically from the first object keys
  const headers = Object.keys(data[0]);

  return (
    <div
      style={{
        overflowX: "auto",
        border: "1px solid #ddd",
        borderRadius: 6,
        padding: 10,
        backgroundColor: "#fff"
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: 14,
          textAlign: "left"
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#f4f6f8" }}>
            {headers.map((header) => (
              <th
                key={header}
                style={{
                  borderBottom: "1px solid #ddd",
                  padding: "8px 10px",
                  textTransform: "capitalize",
                  fontWeight: "600"
                }}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              style={{
                backgroundColor:
                  rowIndex % 2 === 0 ? "#fff" : "#fafafa"
              }}
            >
              {headers.map((header) => (
                <td
                  key={header}
                  style={{
                    borderBottom: "1px solid #eee",
                    padding: "8px 10px"
                  }}
                >
                  {row[header] || "-"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

ShiftTable.propTypes = {
  data: PropTypes.array.isRequired
};

export default ShiftTable;
